import style from "./VLSegmented.module.scss";
import { ConfigProvider, Segmented, SegmentedProps } from "antd";
import classNames from "classnames";

export const vlSegmentedGradientToggleTheme = {
  itemColor: "var(--new-text-on-surface-500)",
  itemSelectedColor: "var(--new-text-on-primary)",
  itemHoverColor: "var(--new-text-on-primary)",
  colorTextDisabled: "var(--new-text-on-surface-400-alt)",
} as const;

export type VLSegmentedProps = SegmentedProps & {
  gradientToggle?: boolean;
};

export const VLSegmented = ({
  className,
  gradientToggle,
  ...props
}: VLSegmentedProps) => {
  const segmented = (
    <Segmented {...props} className={classNames(style.segmented, className)} />
  );

  if (!gradientToggle) {
    return segmented;
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: vlSegmentedGradientToggleTheme,
        },
      }}
    >
      {segmented}
    </ConfigProvider>
  );
};
